import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AddClient from "./pages/AddClient";
import EditClient from "./pages/EditClient";
import EditInvestment from "./pages/EditInvestment";
import ClientInvestments from "./pages/ClientInvestments";
import ClientHistory from "./pages/ClientHistory";
import WithdrawAmount from "./pages/WithdrawAmount";
import UserLogin from "./pages/UserLogin";
import UserDashboard from "./pages/UserDashboard";
import MyAccount from "./pages/MyAccount";
import InvestmentDetails from "./pages/InvestmentDetails";
import ContactUs from "./pages/ContactUs";
import TransactionsLedger from "./pages/TransactionsLedger";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { PublicRoute } from "./components/PublicRoute";
import AddInvestment from "./pages/AddInvestment";
import FDCalculator from "./pages/FDCalculator";

function AppRoutes() {
  const { isAuthenticated, user, loading } = useAuth();
  //   // console.log(
  //     "AppRoutes: isAuthenticated:",
  //     isAuthenticated,
  //     "user:",
  //     user,
  //     "loading:",
  //     loading
  //   );

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-xl font-semibold">Loading...</div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route
        path="/login"
        element={
          <PublicRoute role="user">
            <UserLogin />
          </PublicRoute>
        }
      />
      <Route
        path="/admin/login"
        element={
          <PublicRoute role="admin">
            <AdminLogin />
          </PublicRoute>
        }
      />

      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute role="admin">
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/clients/add"
        element={
          <ProtectedRoute role="admin">
            <AddClient />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/clients/:userId/edit"
        element={
          <ProtectedRoute role="admin">
            <EditClient />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/clients/:userId/history"
        element={
          <ProtectedRoute role="admin">
            <ClientHistory />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/clients/:userId/investments"
        element={
          <ProtectedRoute role="admin">
            <ClientInvestments />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/clients/:userId/investments/add"
        element={
          <ProtectedRoute role="admin">
            <AddInvestment />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/clients/:userId/investments/:fdNumber"
        element={
          <ProtectedRoute role="admin">
            <InvestmentDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/clients/:userId/investments/:fdNumber/edit"
        element={
          <ProtectedRoute role="admin">
            <EditInvestment />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/clients/:userId/investments/:fdNumber/withdraw"
        element={
          <ProtectedRoute role="admin">
            <WithdrawAmount />
          </ProtectedRoute>
        }
      />
      <Route
        path="/investments/:fdNumber/withdraw"
        element={
          <ProtectedRoute role="user">
            <WithdrawAmount />
          </ProtectedRoute>
        }
      />
      <Route
        path="/:userId"
        element={
          <ProtectedRoute role="user">
            <UserDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/my-account"
        element={
          <ProtectedRoute role="user">
            <MyAccount />
          </ProtectedRoute>
        }
      />
      <Route
        path="/transactions-ledger"
        element={
          <ProtectedRoute role="user">
            <TransactionsLedger />
          </ProtectedRoute>
        }
      />
      {/*Admin transaction routes*/}
      <Route
        path="/admin/transactions-ledger"
        element={
          <ProtectedRoute role="admin">
            <TransactionsLedger />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/clients/:userId/transactions-ledger"
        element={
          <ProtectedRoute role="admin">
            <TransactionsLedger />
          </ProtectedRoute>
        }
      />
      <Route
        path="/investments/:fdNumber"
        element={
          <ProtectedRoute role="user">
            <InvestmentDetails />
          </ProtectedRoute>
        }
      />

      <Route path="/apply" element={<ContactUs />} />
      <Route path="/fd-calculator" element={<FDCalculator />} />

      <Route
        path="*"
        element={
          isAuthenticated ? (
            <Navigate
              to={
                user.role === "admin" ? "/admin/dashboard" : `/${user.userId}`
              }
              replace
            />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Navbar />
        <div className="container">
          <AppRoutes />
        </div>
      </Router>
    </AuthProvider>
  );
}
